// @flow

export { SelectLang } from './select-lang';
